var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_vm._v("\n  New content available. Please\n  "),_c('span',{staticClass:"refresh-btn",on:{"click":_vm.refresh}},[_vm._v("\n    REFRESH\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }